import React from 'react';
import {
  Badge,
  Button,
  Stack,
  Tooltip,
} from '@mui/material';
import {
  OutlinedIcons, Fab,
} from '@marageti/z4-lib';
import { LoadingButton } from '@mui/lab';
import LogCallModal from '../modals/log-call-modal';

type TripRequestActionBarProps = {
  travelerToZicassoId: string;
  loading?: boolean;
  disableMatch: boolean;
  disableScreen: boolean;
  notAssignedMessage: string;
  isScreened: boolean;
  screenMessage: string;
  onMatch: () => void;
  onScreen: () => void;
  onChat: () => void;
  onLogCall: () => void;
  onLogCallClose: () => void;
  logCallModalOpen: boolean;
  screenFailureReasons: number;
  hasUnreadChatMessages: boolean;
};

const TripRequestActionBar = ({
  travelerToZicassoId,
  disableMatch,
  disableScreen,
  notAssignedMessage,
  isScreened,
  screenMessage,
  onMatch,
  onScreen,
  onChat,
  onLogCall,
  onLogCallClose,
  logCallModalOpen,
  loading = true,
  screenFailureReasons,
  hasUnreadChatMessages,
}: TripRequestActionBarProps) => (
  <>
    <Fab anchorId="oryx-footer" sx={{ py: 2, border: 0, boxShadow: '0px -2px 16px 0px rgba(13, 23, 24, 0.07)' }}>
      <Stack direction="row" spacing={1.5}>
        <Tooltip title={notAssignedMessage}>
          <span>
            <Button variant="contained" onClick={onMatch} disabled={disableMatch}>
              Match
            </Button>
          </span>
        </Tooltip>
        <Tooltip title={notAssignedMessage || screenMessage}>
          <Badge
            component="span"
            invisible={isScreened}
            onClick={disableScreen ? undefined : onScreen}
            badgeContent={`${screenFailureReasons}`}
            color={screenFailureReasons > 0 ? 'error' : 'success'}
            sx={(theme) => ({
              '& .MuiBadge-badge': {
                cursor: 'pointer',
                top: '5px',
                right: '5px',
                border: '2px solid white',
                backgroundColor: screenFailureReasons > 0 ? theme.palette.error.main : theme.palette.success.main,
                color: 'white',
                fontSize: '10px',
                minHeight: '22px',
                minWidth: '22px',
              },
            })}
          >
            <Button
              variant="outlined"
              onClick={(event) => {
                event.stopPropagation();
                onScreen();
              }}
              disabled={disableScreen}
            >
              {isScreened ? 'Screened' : 'Screen'}
            </Button>
          </Badge>
        </Tooltip>
        <Tooltip title="Log Call / Text Message">
          <LoadingButton
            variant="outlined"
            component="span"
            sx={{ width: '46px', minWidth: '46px' }}
            onClick={onLogCall}
            loading={loading}
          >
            <OutlinedIcons.OutlinedPhoneOutgoingIcon width={24} height={24} />
          </LoadingButton>
        </Tooltip>
        <Tooltip title="Message Traveler">
          <Badge
            component="span"
            badgeContent={' '}
            color="info"
            invisible={!hasUnreadChatMessages}
            sx={(theme) => ({
              '& .MuiBadge-badge': {
                top: '3px',
                right: '3px',
                border: '2px solid white',
                backgroundColor: theme.palette.info.main,
                color: 'white',
                minWidth: '10px',
                minHeight: '10px',
                width: '14px',
                height: '14px',
              },
            })}
          >

            <LoadingButton
              variant="outlined"
              sx={{ width: '46px', minWidth: '46px' }}
              onClick={onChat}
              loading={loading}
            >
              <OutlinedIcons.OutlinedChatIcon width={24} height={24} />
            </LoadingButton>
          </Badge>
        </Tooltip>
      </Stack>
    </Fab>
    <LogCallModal
      open={logCallModalOpen}
      onClose={onLogCallClose}
      conversationId={travelerToZicassoId}
    />
  </>
);

export default TripRequestActionBar;
